import React from 'react';

import PropTypes from 'prop-types';

const TooltipAvatarContent = ({ slug, plan = null }) => {
    return (
        <div className="flex max-w-[200px] flex-col overflow-hidden">
            <span className="overflow-hidden text-ellipsis whitespace-nowrap">{slug}</span>
            {plan ? (
                <span className="font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {plan}
                </span>
            ) : null}
        </div>
    );
};

TooltipAvatarContent.propTypes = {
    slug: PropTypes.string,
    plan: PropTypes.string
};

export default TooltipAvatarContent;
